import type { ReferencedEntity } from "@cohesive/api-client";

export function entityRefKey(e: ReferencedEntity): string {
  return `${e.entity_id}:${e.entity_type}:${e.platform}`;
}

/** Canvas node references plus file-record text excerpt references. */
export function mergeCanvasReferencedEntities(
  canvasEntities: ReferencedEntity[],
  textSelectionEntities: ReferencedEntity[],
  removedEntityIds: Set<string>,
): ReferencedEntity[] {
  return [
    ...canvasEntities.filter((e) => !removedEntityIds.has(e.entity_id)),
    ...textSelectionEntities,
  ];
}

/** Dedupe by entity id, type, and platform; message/editor entities first, then canvas/external. */
export function mergeMessageAndCanvasReferencedEntities(
  fromMessage: ReferencedEntity[] | undefined,
  fromCanvas: ReferencedEntity[],
): ReferencedEntity[] {
  const merged = [...(fromMessage ?? [])];
  const keys = new Set(merged.map(entityRefKey));
  for (const e of fromCanvas) {
    const k = entityRefKey(e);
    if (!keys.has(k)) {
      keys.add(k);
      merged.push(e);
    }
  }
  return merged;
}
